/**
 *
 * RequestType14326 constants
 *
 */

export const BLOCKING_OR_ADDITIONAL_CARD_LEVEL = '4022408710000';
export const ENGINEERING_SERVICE = '3724900074000';
